import { RangePickerProps } from "antd/es/date-picker"
import moment from "moment"

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  // Can not select days before today and today
  return current < moment().endOf('day')
}